import React, { createContext, useState } from "react";

export const UploadCsvContext = createContext({
  current: 0,
  setCurrent: () => {},
  isblocked: false,
  setIsBlocked: () => {},
});

export const UploadCsvStepsProvider = ({ children }) => {
  const [current, setCurrent] = useState(0);
  const [isblocked, setIsBlocked] = useState(false);

  const value = {
    current,
    setCurrent,
    isblocked,
    setIsBlocked,
  };

  return <UploadCsvContext.Provider value={value}>{children}</UploadCsvContext.Provider>;
};
